import { gql } from "@stadium/services/apollo-client";

import { US_CURRENCY_CODE } from "@constants/store";
import { BASIC_VARIANT_PRICE_DETAILS } from "@graphql/fragments/product/basic-variants-price-details";
import { PRODUCT_OPTION_TYPES } from "@graphql/fragments/product/option-types";
import { ALL_VARIANTS_DETAILS } from "@graphql/fragments/product/all-variant-details";

import { DIGITAL_ASSET_CONTENT } from "@stadium/shared/src/graphql/fragments/digital-assets/digital-asset-content";

export const fetchVariantsList = gql`
  query variants(
    $country: String!
    $storeNumber: String!
    $externalSourceIds: String
    $catalogExternalStoreProductMappings: String!
    $isProductVariantsListRequired: Boolean = false
    $currency: String = "${US_CURRENCY_CODE}"
    $globalZone: Boolean
    $isVaraintSelectionDataRequired:Boolean=false
    $fetchDigitalAssets:Boolean=false
    $after: String
    $first: Int = 20
    $kind: String = "logo"
    $ids: [Int!]
    $limitQueryFields: Boolean = false
  ) {
    digitalAssets(after: $after, first: $first, kind: $kind, ids: $ids) @include(if: $fetchDigitalAssets) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
      }
      nodes {
        ...DigitalAssetContent
        designGuidelines {
          ...DigitalAssetContent
        }
      }
    }
    variants(country: $country, storeNumber: $storeNumber, externalSourceIds: $externalSourceIds) {
      id
      minOrderableQuantity
      externalId
      isMaster
      images(storeNumber: $storeNumber, catalogExternalStoreProductMappings: $catalogExternalStoreProductMappings)
      optionValues {
        id
        name
        presentation
        optionType {
          key
          name
        }
      }
      catalogVariants(
        catalogExternalStoreProductMappings: $catalogExternalStoreProductMappings
        storeNumber: $storeNumber
      ) {
        catalogStoreExternalId
        images
        productSlug
        catalogStoreId
        designed
      }
      masterImages(
        catalogExternalStoreProductMappings: $catalogExternalStoreProductMappings
        storeNumber: $storeNumber
      ) @skip(if: $limitQueryFields) {
        catalogStoreExternalId
        images
      }
      allVariants: allOptimizedVariants (
        catalogExternalStoreProductMappings: $catalogExternalStoreProductMappings
        storeNumber: $storeNumber
      ) @include(if: $isVaraintSelectionDataRequired){
        ...AllVariantsDetails
      }
      product {
        id
        name
        slug
        catalogStoreId
        currentCatalogExternalStoreId
        bulkAvailable
        intent
        outOfStock
        askForPreference
        askForRestriction
        shippedSeparately
        hasTierPricing
        variantImages(storeNumber: $storeNumber) @skip(if: $limitQueryFields)
        variantsIncludingMaster(number: $storeNumber, country: $country) @include(if: $isProductVariantsListRequired) {
          ... on Price {
            ...BasicVariantPriceDetails
          }
        }
        brand(country: $country, globalZone: $globalZone) {
          id
          displayName: name
        }
        vendorByCountry: vendorByCountryOrGlobalZone(country: $country, globalZone: $globalZone) {
          id
          displayName
          externalId
          visible
        }
        masterVariant {
          ... on Variant {
            id
            priceIn(currency: $currency)
            externalId
            prices(currency: $currency) {
              max
              min
              priceIn(currency: $currency)
              id
            }
          }
        }
        optionTypes @include(if: $isVaraintSelectionDataRequired){
          ...OptionTypes
        }
      }
    }
  }
  ${BASIC_VARIANT_PRICE_DETAILS}
  ${PRODUCT_OPTION_TYPES}
  ${ALL_VARIANTS_DETAILS}
  ${DIGITAL_ASSET_CONTENT}
`;

export const fetchVariantsListForLockerProductCheck = gql`
  query variants(
    $country: String!
    $storeNumber: String!
    $externalSourceIds: String
    $catalogExternalStoreProductMappings: String!
  ) {
    variants(country: $country, storeNumber: $storeNumber, externalSourceIds: $externalSourceIds) {
      id
      externalId
      catalogVariants(
        catalogExternalStoreProductMappings: $catalogExternalStoreProductMappings
        storeNumber: $storeNumber
      ) {
        catalogStoreExternalId
        lockerProduct
      }
    }
  }
`;
